const location = {
  address1: "2924 Sixth Line",
  address2: "Collingwood, ON",
  addresses: [
    {
      title: "Collwest",
      address1: "2924 Sixth Line",
      address2: "Collingwood, L9Y 3Z1",
      coordinate: { lat: 44.490419, lng: -80.180766 },
    },
    {
      title: "Fairfield Farms",
      address1: "197314 Grey Road #7",
      address2: "Meaford, ON N4L 1W7",
      coordinate: { lat: 44.546231, lng: -80.574400 },
    },
    {
      title: "Highland Custom Farming",
      address1: "300141 Road 180",
      address2: "Proton Station, ON N0C 1L0",
      coordinate: { lat: 44.215417, lng: -80.505221 },
    },
  ],
  phone: "705-445-2121",
  email: null,
  teamProfile: [],
  coordinate: {
    lat: 44.490419,
    lng: -80.180766,
  },
};

export default location;
